export const TaskActionTypes = {
  LOAD_TODOS: 'LOAD_TODOS',
  CLEAR_TODOS_ARRAY: 'CLEAR_TODOS_ARRAY',
  ADD_TODO: 'ADD_TODO',
  TOGGLE_TODO_DONE_STATE: 'TOGGLE_TODO_DONE_STATE',
  EDIT_TODO: 'EDIT_TODO',
  TOGGLE_TODO_TO_BE_DELETED_STATE: 'TOGGLE_TODO_TO_BE_DELETED_STATE',
  DELETE_TODO_PERMANENTLY: 'DELETE_TODO_PERMANENTLY',
  SET_LOADING_STATE: 'SET_TASK_LOADING_STATE',
  SET_DIALOG: 'SET_TASK_DIALOG'
}
